"use client"

import Next13ProgressBar from "next13-progressbar"

export function ProgressBar() {
  return <Next13ProgressBar height="1px" color="#000" options={{ showSpinner: false }} showOnShallow />
}
